import { useEffect, useState } from "react";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import DisplayExport from "../../../components/Exports/DisplayExport";
import { TextField, Button } from "@mui/material";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import MenuItem from "@mui/material/MenuItem";

function PreSXPProgrammeData() {
  const { logout } = StaffuseAuth();

  const [data, setdata] = useState([]);
  const [status, setStatus] = useState(false);

  let Variables = [
    {
      Q: "Accomodation_Arrival_Information_Title",
      Text: "e.g. Garden Halls",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Accomodation_Arrival_Information_Address",
      Text: "e.g. 1 Cartwright Gardens, London, WC1H 9EN",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Accomodation_Emergancy_Number",
      Text: "e.g. 07445 111 222",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Accomodation_Emergancy_Email",
      Text: "e.g. gardenhalls@investin.org",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Accomodation_DropBox_Link",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Non_Accomodation_Arrival_Address",
      Text: "e.g. Dukes House, WN1 111",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_1_week_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_2_week_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_premium_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_1_week_non_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_2_week_non_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Timetable_DropBox_Link_premium_non_accom",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Resources_DropBox_Link",
      Text: "This is optional e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Need_Laptop",
      Text: "Must be Yes or No, nothing else please !",
      RepeatForEntrGRoupB: "No",
    },
    // {
    //   Q: "Premium_Timetables_DropBox_Link",
    //   Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
    //   RepeatForEntrGRoupB: "No",
    // },
    {
      Q: "What_To_Bring_Extra",
      Text: ", this is optional and can be left blank, e.g. Please also bring a camera if you have one",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Custom_Field_Extra",
      Text: ", this is optional and can be left blank, this will go at the bottom of the email. e.g. Please download the XXX software on www.YYY.com before the programme for the stocks and shares day.",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Post_Programme_Slides_1_week",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },
    {
      Q: "Post_Programme_Slides_2_week",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },{
      Q: "Post_Programme_Slides_premium",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "Yes",
    },{
      Q: "Post_Programme_Assessment_Link",
      Text: "e.g. https://docsend.com/view/rnvs9duznm46ht44",
      RepeatForEntrGRoupB: "No",
    },
    {
      Q: "Post_Programme_Any_Other_Text",
      Text: "e.g. Dont forgot to check out www.XYZ.com for more information on that thing we covered",
      RepeatForEntrGRoupB: "No",
    },
  ];

  useEffect(() => {
    Get_All_From_MongoDB(
      "Lookups",
      "Programmes_2025_PreSXPProgramme",
      (res) => {
        setdata(res);
      },
      logout
    );
  }, [logout]);

  const handleFieldChange = (id, field, value) => {
    setdata((prevData) =>
      prevData.map((programme) =>
        programme._id === id ? { ...programme, [field]: value } : programme
      )
    );
  };

  const handleSave = (e, programme) => {
    e.preventDefault();

    let chosenID = programme._id;
    let updateDoc = programme;
    delete updateDoc._id;
    Update_To_MongoDB_By_ID(
      updateDoc,
      "Lookups",
      "Programmes_2025_PreSXPProgramme",
      setStatus,
      chosenID,
      logout
    );
    //use e.target.value to get the button grey and disabled
    e.target.disabled = true;
    e.target.innerText = "Saved";
    e.target.style.backgroundColor = "#85c1e9";
    e.target.style.color = "white";
  };

  return (
    <div>
      <DisplayExport excelData={data} fileName="Programmes_2025" />
      <h1>Programme List</h1>
      <h1>
        This page is very large and VERY slow, i suggest you copy and paste in
        and out of here instead of typing directly.
      </h1>
      <h3>Programmes Count: {data.length}</h3>
      <br />
      {data.map((programme, index) => (
        <div
          key={programme._id || index}
          style={{ marginBottom: 32, border: "1px solid #ccc", padding: 16 }}
        >
          <h3>
            {programme.Title} <br />
            <span style={{ fontWeight: "normal" }}>{programme.Dates}</span>
          </h3>
          {Variables.map((variable) => (
            <>
              <p>
                {variable.Q.replaceAll("_", " ")}, {variable.Text}
              </p>
              {
              variable.Q === "Accomodation_Arrival_Information_Title"
               ? 
              <>
                <TextField
                key={variable.Q}
                label={variable.Q}
                variant="outlined"
                margin="normal"
                fullWidth
                value={programme[variable.Q] || ""}
                onChange={(e) =>
                  handleFieldChange(programme._id, variable.Q, e.target.value)
                }
                InputProps={{ style: { backgroundColor: "white" } }}
              select
              >
                <MenuItem key={""} value={""}>
            NULL
          </MenuItem>
          <MenuItem key={"Garden Halls"} value={"Garden Halls"}>
            Garden Halls
          </MenuItem>
          <MenuItem key={"College Halls"} value={"College Halls"}>
            College Halls
          </MenuItem>
          <MenuItem key={"International Halls"} value={"International Halls"}>
            International Halls
          </MenuItem>
          </TextField>
              </> : 
              <>
              <TextField
                key={variable.Q}
                label={variable.Q}
                variant="outlined"
                margin="normal"
                fullWidth
                value={programme[variable.Q] || ""}
                onChange={(e) =>
                  handleFieldChange(programme._id, variable.Q, e.target.value)
                }
                InputProps={{ style: { backgroundColor: "white" } }}
              />
              </>
              }
            </>
          ))}
          {programme.Title === "The Young Entrepreneur Summer Experience" &&
          programme.Dates === "(7th July - 18th July 2025)" ? (
            <>
              {Variables.filter((variable) => variable.RepeatForEntrGRoupB === "Yes").map(
                (variable) => (
                  <>
                    <p>
                      Grouo B: {variable.Q.replaceAll("_", " ")},{" "}
                      {variable.Text}
                    </p>
                    <TextField
                      key={variable.Q + "_GroupB"}
                      label={variable.Q + "_GroupB"}
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      value={programme[variable.Q + "_GroupB"] || ""}
                      onChange={(e) =>
                        handleFieldChange(
                          programme._id,
                          variable.Q + "_GroupB",
                          e.target.value
                        )
                      }
                      InputProps={{ style: { backgroundColor: "white" } }}
                    />
                  </>
                )
              )}
            </>
          ) : (
            <></>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={(e) => handleSave(e, programme)}
            style={{ marginTop: 8 }}
          >
            Save
          </Button>
        </div>
      ))}
    </div>
  );
}

export default PreSXPProgrammeData;
